(() => {
  const header = document.querySelector('.wl-header');
  if (!header) return;
  const preview = new URLSearchParams(location.search).get('preview_theme_id');
  if (preview) {
    document.querySelectorAll('.wl-header a, .wl-footer a, .wl-about a').forEach(link => {
      const url = new URL(link.href, location.origin);
      if (url.origin === location.origin && !url.pathname.includes('/account')) {
        url.searchParams.set('preview_theme_id', preview);
        link.href = url.href;
      }
    });
  }
  const scienceLink = document.querySelector('[data-wl-home] .skip[href="#science"]');
  if (scienceLink) {
    const goScience = () => scienceLink.click();
    document.addEventListener('click', event => {
      const link = event.target.closest('a[href]');
      if (!link || link.closest('[data-wl-home]') || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button > 0) return;
      const url = new URL(link.href, location.href);
      if (url.origin === location.origin && url.pathname === location.pathname && url.hash === '#science') {
        event.preventDefault();
        history.pushState(null, '', url);
        goScience();
      }
    });
    window.addEventListener('hashchange', () => { if (location.hash === '#science') goScience(); });
    const restoreScience = () => { if (location.hash === '#science') requestAnimationFrame(goScience); };
    if (document.readyState === 'loading' || document.readyState === 'interactive') document.addEventListener('DOMContentLoaded', restoreScience, {once: true});
    else restoreScience();
  }
  const disclosures = [...header.querySelectorAll('[data-wl-nav-disclosure], [data-wl-language]')];
  disclosures.forEach(disclosure => {
    const summary = disclosure.querySelector('summary');
    summary.setAttribute('aria-expanded', String(disclosure.open));
    disclosure.addEventListener('toggle', () => {
      summary.setAttribute('aria-expanded', String(disclosure.open));
      if (disclosure.open) disclosures.forEach(other => {
        if (other !== disclosure && !other.contains(disclosure)) other.open = false;
      });
    });
  });
})();
